(ns ncr.reports.projects
  (:require
   [clojure.core.match :refer [match]]
   [ncr.charts :as charts]
   [ncr.reports.grid-cell :as gc]
   [ncr.reports.details]
   [ncr.reports.explain]
   [ncr.reports.common :as rc]))

(defn- summary-row [report path props]
  (gc/data-row report path props
    {:extension ncr.reports.explain/c-explain-project}))

(defn- summary [report [income expense pnl]]
  [(summary-row report income {:heading "Income"})
   (summary-row report expense {:heading "Expense"})
   (summary-row report pnl {:heading "PnL" :colorize? true})])

(defn- task-row [report path [task-id task-name]]
  (let [path (assoc path :cube-path [task-id])
        paths (rc/income-expense-pnl-paths path)]
    (gc/data-row report (assoc path :sym-path [])
      {:heading [charts/c-header-with-experimental-charts-button {:header task-name :report report :paths paths}]
       :colorize? true}
      {:extension ncr.reports.explain/c-explain-project
       :sub-rows
       (summary report paths)
       :filter-zeroes? true})))

(defn- glob-row [report path glob tasks]
  (let
    [path (assoc path :cube-path [glob])
     glob (first glob)
     paths (rc/income-expense-pnl-paths path)]
    (match (into [] tasks)
      []
      nil

      [task]
      (task-row report path task)

      tasks'
      (gc/data-row report path
        {:colorize? true
         :heading [charts/c-header-with-experimental-charts-button {:header glob :report report :paths paths}]}
        {:extension ncr.reports.explain/c-explain-project
         :sub-rows
         (concat
           (for [task (sort-by val tasks')]
             (task-row report path task))
           (summary report paths))
         :filter-zeroes? true}))))

(defn render [{:keys [labels] :as report} {:keys [heading]}]
  (let
    [path {:report-path [:projects-teams :projects]}
     cube (rc/from-path report path)
     values (get-in cube [:axes 0 :values :total])
     paths (rc/income-expense-pnl-paths (assoc path :cube-path [:total]))]
    (concat
      [{:type :header
        :heading [charts/c-header-with-experimental-charts-button {:header heading :report report :paths paths}]}]
      (apply concat
        (for [[glob tasks] (sort-by key values)]
          [(glob-row report
             (assoc path :sym-path []) glob (select-keys labels tasks))]))
      (summary report paths))))
